import { createSlice } from '@reduxjs/toolkit';

const initialState = { data: null, status: 'idle', error: null };

const acceptDeclineInviteSlice = createSlice({
  name: 'acceptDeclineInvite',
  initialState,
  reducers: {
    acceptDeclineInviteRequest(state) {
      state.status = 'loading';
      state.error = null;
    },
    acceptDeclineInviteSuccess(state, action) {
      state.status = 'succeeded';
      state.data = action.payload;
    },
    acceptDeclineInviteFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    acceptDeclineInviteReset(state) {
      state.status = 'idle';
      state.error = null;
      state.data = null;
    },
  },
});

export const acceptDeclineInviteAction = acceptDeclineInviteSlice.actions;
export default acceptDeclineInviteSlice;